import React from 'react';

const HorizontalBar = () => {
  return (
    <div
      style={{
        borderBottom: '2px solid #F4F0EE',
        margin: '15px 0'
      }}
    />
  );
};

export default HorizontalBar;
